import { schema } from "normalizr";
import { ChatMessage } from "./chat-message";

export const ChatMessages = new schema.Array(ChatMessage);
